/**
 * @ngdoc directive
 * @name Button Spinner
 *
 * @description
   Button that changes name to spinner icon and gets disabled when inProgress param is truthy
 *
 * @scope
 * @param {String} name - button name
 * @param {Boolean} inProgress - show spinner instead of name when truthy
 * @param {Function} disabledOn - disable button
 *
 * @example
    <button-spinner
      name="Save (Click me)"
      in-progress="isInProgress.result"
      ng-click='onBtnSpinnerClick()'
      class="btn-primary pull-left"
      disabled-on='getFalse()'
      >
    </button-spinner>

    <button-spinner
      name="Save (In Progress)"
      in-progress="'true'"
      class="btn-primary pull-left margin-left-sm"
      >
    </button-spinner>

    <button-spinner
      name="Save (Disabled)"
      in-progress=""
      class="btn-primary pull-left margin-left-sm"
      disabled-on="getTrue()"
      >
    </button-spinner>
 */

(function() {

  buttonSpinner.$inject = ["PATH"];
  app.directive('buttonSpinner', buttonSpinner);

  function buttonSpinner (PATH) {
    var directive = {
      replace: true,
      restrict: 'E',
      scope: {
        name: '@',
        inProgress: '=',
        disabledOn: '&?'
      },
      templateUrl: PATH.components + 'buttonSpinner/buttonSpinner.html'
    };

    return directive;
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/buttonSpinner/buttonSpinnerDirective.js